import { action, computed, makeObservable } from "mobx"

import { PaymentsEntity } from "@src/app/paymentsStore/PaymentsEntity"
import {
  PaymentInfoType,
  RefundCreateRequest,
  RefundEntity,
} from "@src/shared/componemts/RefundForm/classses/RefundEntity"

export class PaymentRefundEntity extends RefundEntity {
  constructor(private payment: PaymentsEntity) {
    super()

    makeObservable(this, {
      create: action.bound,
      paymentId: computed,
      paymentInfo: computed,
    })
  }

  async create(req: RefundCreateRequest): Promise<boolean> {
    if (!this.payment.isRealExchanged) {
      return this._create(req)
    }

    const exchange = await this.payment.getConvertToken()

    if (!exchange) {
      return false
    }

    return this._create({ ...req, convert_token: exchange.token })
  }

  get paymentId() {
    return this.payment.state.id
  }

  get paymentInfo(): PaymentInfoType {
    if (this.payment.exchange) {
      return {
        amount: this.payment.exchange.amount,
        network: this.payment.exchange.network,
        symbol: this.payment.exchange.symbol,
      }
    }

    return {
      amount: this.payment.state.amount,
      network: this.payment.state.network,
      symbol: this.payment.state.symbol,
    }
  }
}
